const telegramPhonePattern = /^\+?[0-9()\s-]+$/
const telegramUsernamePattern = /^@[a-zA-Z0-9_]{5,32}$/

export const toTelegramHref = (value: string | null) => {
  const contact = value?.trim()
  if (!contact) {
    return null
  }

  if (telegramUsernamePattern.test(contact)) {
    return `https://t.me/${contact.slice(1)}`
  }

  if (telegramPhonePattern.test(contact)) {
    const digits = contact.replace(/\D/g, '')
    if (digits.length === 11 && (digits.startsWith('7') || digits.startsWith('8'))) {
      return `https://t.me/+7${digits.slice(1)}`
    }
  }

  try {
    const url = new URL(contact)
    return url.protocol === 'https:' && url.hostname === 't.me' && !url.username && !url.password && !url.port
      ? contact
      : null
  } catch {
    return null
  }
}
